export default "__VITE_ASSET__JO3X4EOK__"